/** Display format used everywhere in the EPC project wizard. */
export const DATE_DISPLAY_FORMAT = 'MM-DD-YYYY';

/** 'YYYY-MM-DD' → 'MM-DD-YYYY'. Empty/invalid → em dash. */
export function mdy(value: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (!m) return '—';
  return `${m[2]}-${m[3]}-${m[1]}`;
}

/** ISO timestamp → 'MM-DD-YYYY' (UTC date part). Missing/invalid → em dash. */
export function isoToMdy(iso: string | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return mdy(d.toISOString().slice(0, 10));
}

/** Date-input 'YYYY-MM-DD' → ISO string, or undefined for blank/invalid. */
export function dateInputToIso(value: string): string | undefined {
  if (!value.trim()) return undefined;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? undefined : d.toISOString();
}

/** ISO string → date-input 'YYYY-MM-DD' ('' for missing/invalid). */
export function isoToDateInput(iso: string | undefined): string {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
}

export function daysBetween(a: Date, b: Date): number {
  return Math.round((b.getTime() - a.getTime()) / 86_400_000);
}

/** Duration between two 'YYYY-MM-DD' values. Null when incomplete or inverted. */
export function durationParts(startYmd: string, endYmd: string): { days: number; months: string } | null {
  if (!startYmd || !endYmd) return null;
  const a = new Date(startYmd);
  const b = new Date(endYmd);
  if (Number.isNaN(a.getTime()) || Number.isNaN(b.getTime())) return null;
  const days = daysBetween(a, b);
  if (days < 0) return null;
  return { days, months: (days / 30.4375).toFixed(1) };
}
